export const OBJECTIVES_LOAD_ALL = 'OBJECTIVES_LOAD_ALL'
export const OBJECTIVES_LOAD_ALL_FULFILLED = 'OBJECTIVES_LOAD_ALL_FULFILLED'
export const OBJECTIVES_LOAD_ALL_PENDING = ' OBJECTIVES_LOAD_ALL_PENDING'
export const OBJECTIVES_LOAD_ALL_REJECTED = ' OBJECTIVES_LOAD_ALL_REJECTED'
